import primitives from '@veneer/primitives';
import { isInternetExplorer } from 'src/utils/isInternetExplorer';
import styled from 'styled-components';

// TODO: check if this override is really necessary.
export const Container = styled.button`
  ${(props) => !props.disabled && 'cursor: pointer;'}
  background: none;
  border: none;
  outline: none;
  padding: 0;
  margin-right: 0px !important;
  ${() =>
    isInternetExplorer() &&
    `margin-right: ${primitives.layout.size3}px !important;`}

  &:focus-visible {
    outline: rgb(2, 71, 107) solid 2px;
    outline-offset: 2px;
    border-radius: 50%;
  }
`;
